module.exports = __webpack_public_path__ + "@/assets/img/share.44f104e6.svg";